export default __webpack_public_path__ + "static/media/exito2.fc4f61e2.png";